import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Check, Sprout } from "lucide-react";
import AuthContext from "../../../contexts/AuthContext/AuthContext";
import { getCareTeam } from "../../../services/CareTeamService";
import "./CareTeamNotice.css";

// A strip at the top of the games home. It confirms a connection just made
// on the join page, and points to a provider's request that's waiting, which
// would otherwise sit unseen in Settings → My care team.
const CareTeamNotice = () => {
  const { isSignedIn, isPatient } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [message] = useState(() => location.state?.careMessage || "");
  const [pending, setPending] = useState([]);

  // Show the confirmation once, not again after a reload.
  useEffect(() => {
    if (location.state?.careMessage) {
      navigate(location.pathname, { replace: true, state: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isSignedIn || !isPatient) return undefined;
    let alive = true;
    getCareTeam()
      .then((team) => alive && setPending(team?.pending || []))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [isSignedIn, isPatient]);

  if (!message && !pending.length) return null;
  const asking =
    pending.length === 1 ? pending[0].provider.name : `${pending.length} providers`;

  return (
    <div className="care-notices">
      {message && (
        <p className="care-notice care-notice--done" role="status">
          <Check size={20} aria-hidden="true" />
          <span>{message}</span>
        </p>
      )}
      {pending.length > 0 && (
        <p className="care-notice" role="status">
          <Sprout size={20} aria-hidden="true" />
          <span>{asking} asked to see your progress.</span>
          <Link to="/settings/care-team" className="care-notice__action">
            {pending.length === 1 ? "Review request" : "Review requests"}
          </Link>
        </p>
      )}
    </div>
  );
};

export default CareTeamNotice;
